module.exports = __webpack_public_path__ + "img/very_pale_white.1c544055.svg";